
import React from "react";
import Btn from "../common/Btn";
import MatchCard from "../common/MatchCard";
import { i18nManager } from "../../i18n";
import { pagePath } from "../../helpers";
import { Utils } from "../../../../../utils";
import styles from "../../assets/style.module.css";
import ScrollTrack, { ScrollButtons, useScroller } from "../common/ScrollTrack";
import { ITeamWebsite, ITournamentEditionMatch } from "../../../../../services";

export interface UpcomingMatchesProps {
    publicId: string;
    basePath: string;
    website: ITeamWebsite;
    matches?: ITournamentEditionMatch[];
}

function UpcomingMatches({ website, basePath, publicId, matches }: UpcomingMatchesProps) {

    const labels = i18nManager.Labels.home;
    const scroller = useScroller();

    return (<section className={styles["section-tight"]}>
        <div className={styles["container"]}>
            <div className={styles["row-head"]}>
                <h2 className={styles["h1"]}>{labels.upcoming_matches}</h2>
                {(matches?.length ?? 0) > 1 && (<ScrollButtons onPrev={scroller.prev} onNext={scroller.next} />)}
            </div>
            {!matches ? Utils.loadingState({ padding: "2rem" }) : (matches.length === 0
                ? (<div className={styles["empty"]}>{labels.no_matches}</div>)
                : (<ScrollTrack trackRef={scroller.ref}>
                    {matches.map((m) => (<MatchCard key={m.external_id} match={m} website={website} publicId={publicId} />))}
                </ScrollTrack>))}
            <div className={styles["row-foot"]}>
                <Btn variant="text" to={pagePath(basePath, "SCHEDULE")}>{labels.view_schedule}</Btn>
            </div>
        </div>
    </section>);
}

export default UpcomingMatches;
